import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import React, {ReactNode, Suspense, useEffect, useState} from "react";
import {ErrorBoundary} from "react-error-boundary";
import {IntlProvider} from "react-intl";
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import {getLanguage, getMessages} from "../translations";
import {OrdererTrackingPage} from "./OrdererTrackingPage";
import {ErrorMessage} from "./ErrorMessage";
import {LoadingMessage} from "./LoadingMessage";
import {RecipientTrackingPage} from "./RecipientTrackingPage";

const queryClient = new QueryClient();

function DelayedLoading() {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const timeout = setTimeout(() => setShow(true), 2000);
        return () => clearTimeout(timeout);
    }, []);
    return show ? <LoadingMessage /> : null;
}

function SuspenseErrorBoundary({children}: {children: ReactNode}) {
    return (
        <Suspense fallback={<DelayedLoading />}>
            <ErrorBoundary FallbackComponent={ErrorMessage}>{children}</ErrorBoundary>
        </Suspense>
    );
}

export function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <IntlProvider locale={getLanguage()} messages={getMessages()}>
                <BrowserRouter>
                    <Switch>
                        <Route path="/p/:shareKey">
                            <SuspenseErrorBoundary>
                                <RecipientTrackingPage />
                            </SuspenseErrorBoundary>
                        </Route>
                        <Route path="/o/:shareKey">
                            <SuspenseErrorBoundary>
                                <OrdererTrackingPage />
                            </SuspenseErrorBoundary>
                        </Route>
                        <Route
                            exact
                            path="/"
                            render={({location}) => (
                                <Redirect to={location.hash.replace("#", "")} />
                            )}
                        />
                    </Switch>
                </BrowserRouter>
            </IntlProvider>
        </QueryClientProvider>
    );
}
